import { Buffer } from 'buffer'
import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'flag-icons/css/flag-icons.min.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

// Runtime polyfills some web3 libs (WalletConnect/ethers) expect in the browser.
if (typeof window.global === 'undefined') window.global = window
if (typeof window.Buffer === 'undefined') window.Buffer = Buffer
if (typeof window.process === 'undefined') window.process = { env: {} }

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
